<div class="detail-screen-button" (click)="onClick()">
  <sfc-icon name='{{icon}}' class="button-icon"></sfc-icon>
  <span slot="text">{{name}}</span>
</div>
